module.exports = {
    clgl: {
        formTitle: '车辆管理',
        menuItem: {
            vehicleHome: '车辆主页',
            MyApproval: '我的审批',
            todo: '待处理',
            done: '已处理',
            MyCar: '我的用车',
            MyDispatchTicket: '我的派车单',
            MyApplicaForm: '我的申请单',
            all: '全部',
            draft: '草稿',
            progress: '处理中',
            Ended: '已结束',
            VehicleGl: '派车管理',
            PendingVehicle: '待派车',
            SentCar: '已派车',
            VehicleManagement: '车辆管理',
            carInfo: '车辆信息',
            carInsurance: '车辆保险',
            carAnnualReview: '车辆年审',
            carRepair: '车辆维修',
            DriverMan: '司机管理',
            FuelCardMan: '加油卡管理',
            FuelCardInfo: '加油卡信息',
            FuelCardRecharge: '加油卡充值',
            FuelCardCon: '加油卡消费',
            carRemind: '车辆提醒',
            InsuranceExpires: '保险到期',
            AnnualReviewExpires: '年审到期',
            StatisticalReport: '统计报表',
            UnitVehicle: '单位用车统计',
            RepairCosts: '维修费用统计',
            DriverDriving: '司机出车统计',
            FuelCardRechargetj: '加油卡充值统计',
            FuelCardContj: '加油卡消费统计'
        },
        clxx: {
            fields: {
                index: '序号',
                carNumber: '车牌号',
                carType: '车辆类型',
                carModel: '品牌型号',
                drivingLicense: '行驶证',
                totalPassenger: '载客数',
                carRegistTime: '年审有效期至',
                carSource: '车辆来源',
                carDept: '车辆归属',
                carRegistNumber: '登记证号编号',
                purchaseDate: '购买日期',
                carCode: '车架号',
                payloadQuality: '车辆载重',
                totalTire: '轮胎数',
                carEngineNo: '发动机号',
                carPhoto: '车辆照片'
            },
            carTypeFormat: '1：大型车\r\n2：中型车\r\n3：小型车\r\n4：微型车\r\n',
            clInfo: '车辆信息'
        },
        pageBtns: {
            dispatchCar: '派车',
            refuse: '拒绝',
            delay: '延期',
            ReturnCar: '还车',
            usingCar: '用车',
            Statistics: '统计',
            search: '查询'
        },
        pcgl: {
            directgl: '派车管理',
            directVehicles: '直接派车',
            delayCar: '延期还车',
            zjhCar: '直接还车',
            cancelCar: '确定要取消派车吗？',
            refuseCar: '确定要拒绝派车吗？',
            refuseCarEd: '已拒绝派车！'
        },
        portlet: {
            seat: '座',
            gwap: '公务安排',
            AlreadyBooked: '已预约',
            PendingVehicle: '待派车',
            SentCar: '已派车',
            OutCar: '出车中',
            ReturnedCar: '已还车',
            Rejected: '已拒绝',
            Cancelled: '已取消',
            AccompanyDriver: '随车司机',
            SelfDriving: '自驾',
            ArrivalLocation: '抵达地点',
            Apply: '申请于:{time}',
            status: '状态{status}'
        },
        tjbb: {
            fields: {
                flCreateDept: '用车部门',
                totalPerson: '乘车人数',
                carUseNum: '车辆使用次数',
                driverName: '姓名',
                driverPhone: '电话',
                driverNumber: '驾驶证号',
                drivingAge: '司机驾龄',
                driverType: '驾驶证类别',
                driverNum: '出车次数'
            },
            StatisticalCycle: '统计周期:',
            startTime: '开始日期',
            endTime: '结束日期',
            UnitVehicle: '单位用车统计',
            dept: '部门',
            num: '次数',
            yearYk: '{curYear1}年加油卡充值统计',
            JykTable: {
                cardNumber: '加油卡号',
                carNumber: '车牌号',
                one: '1月',
                two: '2月',
                three: '3月',
                four: '4月',
                five: '5月',
                six: '6月',
                seven: '7月',
                eight: '8月',
                nine: '9月',
                ten: '10月',
                eleven: '11月',
                twelve: '12月',
                total: '合计(元)',
                Recharge: '{curYear2}年充值费用（元）',
                RechargeFee: '加油卡充值费用',
                AnnualFuelCard: '{curYear1}年加油卡消费统计'
            },
            hj: '合计',
            totalPrice: '总价',
            DriverTrip: '司机出车统计',
            DriverName: '司机名称',
            frequency: '次数',
            DriverUsage: '{date1}至{date2}司机用车统计',
            sjyc: {
                contentEnter: '请输入内容'
            },
            AnnualMain: '{curYear1}年维修费用统计',
            DisDetai: '派车详情',
            isDelete: '确定要删除该条数据吗？'
        },
        sjxx: {
            //司机信息
            formTitle: '司机信息',
            fields: {
                registNumber: '登记证号编号',
                remark: '备注',
                driverRegistTime: '驾驶证登记日期 ',
                driverPhone: '联系电话',
                driverDept: '所属部门',
                carNumber: '关联车牌号',
                drivingAge: '司机驾龄',
                driverType: '驾驶证类别 ',
                driverPhoto: '司机照片',
                driverName: '司机姓名',
                driverNumber: '驾驶证号'
            }
        },
        clbx: {
            //车辆保险表
            formTitle: '车辆保险表',
            fields: {
                enterTime: '保险截止日期 ',
                carNumber: '车牌号',
                beginTime: '保险开始日期 ',
                aggregateCost: '合计费用'
            }
        },
        clfy: {
            //车辆费用登记
            formTitle: '车辆费用登记',
            fields: {
                repairCost: '保养维修费',
                carNumber: '车牌号',
                driver: '驾驶员',
                oilCost: '油费',
                kmNumber: '公里数',
                parkingCost: '停车费',
                driverDept: '所属部门',
                remark: '备注',
                washCarCost: '洗车费',
                roadCost: '路桥费'
            }
        },
        clwx: {
            //车辆维修
            formTitle: '车辆维修',
            fields: {
                carNumber: '车牌号',
                repairHandler: '经办人',
                repairDate: '维修日期 ',
                repairAddress: '维修地点'
            }
        },
        clwxCost: {
            //维修明细
            formTitle: '维修明细',
            fields: {
                repairMoney: '维修费用',
                remark: '备注',
                repairType: '维修明细 '
            }
        },
        jykcz: {
            //加油卡充值
            formTitle: '加油卡充值',
            fields: {
                carNumber: '车牌号',
                rechargeAmount: '本次充值金额',
                rechargeHandler: '经办人',
                cardNumber: '加油卡号',
                rechargeDate: '充值日期 ',
                remark: '备注'
            }
        },
        jykxf: {
            //加油卡消费
            formTitle: '加油卡消费',
            fields: {
                carNumber: '车牌号',
                cardNumber: '加油卡号',
                remark: '备注',
                consumeAmount: '本次消费金额',
                consumeDate: '消费日期 ',
                consumeHandler: '经办人'
            }
        },
        xxxm: {
            //保养/维修的详细项目
            formTitle: '保养/维修的详细项目',
            fields: {
                cost: '费用预计',
                itemName: '项目名称'
            }
        },
        clns: {
            //车辆年审
            formTitle: '车辆年审',
            fields: {
                creator: '经办人',
                inspectionDate: '年审有效期至 ',
                carNumber: '车牌号',
                carRegistTime: '发证日期 ',
                inspectionMoney: '年审费用',
                carType: '车辆类型',
                carDept: '车辆归属',
                carRegistNumber: '登记证编号',
                remark: '备注'
            }
        },
        sendcar: {
            //查看派车
            formTitle: '查看派车',
            fields: {
                flVehPlate: '车牌号',
                flEndTime: '用车结束时间',
                flDrvPhone: '司机电话',
                flPeopleCount: '乘车人数（人）',
                flDst: '抵达地点',
                flMemo: '用车事由',
                flStartTime: '用车开始时间 ',
                returnTime: '实际还车时间',
                draveType: '驾车方式 ',
                flCreateDept: '用车人部门',
                flCreator: '用车人',
                flDrvName: '司机姓名',
                flVehType: '车辆类型 '
            }
        },
        jyk: {
            //加油卡信息
            formTitle: '加油卡信息',
            fields: {
                cardDate: '开卡日期 ',
                cardAddress: '开卡地点',
                cardNumber: '加油卡号',
                residualAmount: '剩余金额',
                remark: '备注',
                carNumber: '车牌号'
            }
        },
        ycsq: {
            //用车申请_惠东住建局
            formTitle: '用车申请_惠东住建局',
            fields: {
                flDrvName: '司机姓名',
                flCreator: '申请人',
                flEndTime: '用车结束时间 ',
                flPlanMileage: '预计里程（KM）',
                flVehPlate: '车辆号牌',
                flSubject: '事由',
                flCreateDate: '申请日期',
                flContent: '备注',
                flPeopleCount: '乘车人数',
                flDst: '目的地',
                flCreateDept: '申请部门',
                flCreatorPhone: '联系电话',
                flVehType: '车辆类型 ',
                flStartTime: '出车时间 ',
                formNumber: '表单流水号',
                flDeparture: '出发地'
            }
        },
        clbxType: {
            //车辆险种表
            formTitle: '车辆险种表',
            fields: {
                companyName: '保险公司',
                insuranceAmount: '保险金额（元）',
                insuranceRate: '费率调整',
                insuranceNum: '保险单号',
                insuranceType: '承担险种 ',
                companyPhone: '联系电话',
                insuranceCost: '保险费（元）'
            }
        },
        bywxsq: {
            //保养/维修申请
            formTitle: '保养/维修申请',
            fields: {
                totalCost: '费用总预计',
                flContent: '备注',
                repairAddress: '维修点',
                flCreatorPhone: '联系方式',
                flCreateDate: '申请日期',
                type: '种类',
                flCreateDept: '申请部门',
                flSubject: '报修原因',
                carNumber: '车牌号',
                flCreator: '申请人'
            }
        }
    }
}
